// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1upOZ","content":"ManualTimeModal_content__2fNhk"};